import { DIVIDER_LENGTH, STATUS_BANNER, STATUS_TEXT_STYLES } from "@dineout-payment-success-ui/constants";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import styled from "styled-components";
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";
import { BANNER_HEIGHT } from "@dineout-payment-success-ui/constants";

export const BgContainerWrapper = styled.div`
    position: relative;
`;

interface IColorKey {
    textColor?: string;
    colorKey: keyof IColors;
}

export const BgContainer = styled(Image)({
    objectFit: "cover",
    width: "100%",
    alignSelf: "center",
    alignItems: "center",
});

export const StyledImage = styled(Image)(({ theme }) => ({
    marginBottom: theme.spacing.medium,
    maxWidth: "450px", // to support dweb usecase
}));

export const StyledImageSelfContained = styled.div(({ theme }) => ({
    height: BANNER_HEIGHT.COMPLETE_IMAGE_WITH_CONTENT,
    marginBottom: theme.spacing.medium,
    width: "100%",
    display: "flex",
    justifyContent: "center",
}));

export const StatusText = styled.div<IColorKey>(({ textColor, colorKey, theme }) => ({
    color: textColor || theme.colors[theme.colorMode][colorKey],
    fontFamily: "Sacramento",
    fontStyle: "normal",
    fontSize: STATUS_TEXT_STYLES.SIZE,
    fontWeight: STATUS_TEXT_STYLES.WEIGHT,
    lineHeight: STATUS_TEXT_STYLES.LINE_HEIGHT,
    letterSpacing: STATUS_TEXT_STYLES.LETTER_SPACING,
    paddingBottom: theme.spacing.xxSmall,
}));

export const StatusTextWrapper = styled.div({
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    top: STATUS_BANNER.TEXT_WRAPPER_TOP,
    width: "100%",
});

export const DividingLine = styled.div(({ theme }) => ({
    borderTop: `1px solid ${theme.colors[theme.colorMode].background_Overlay_Light}`,
    margin: "0 auto",
    marginBottom: theme.spacing.medium,
    width: DIVIDER_LENGTH,
}));

export const GreetingText = styled(Text)(({ theme }) => ({
    lineHeight: theme.spacing.xLarge,
    color: theme.colors[theme.colorMode].positive,
}));

export const StatusDescription = styled(Text)<{ colorKey: keyof IColors }>(({ colorKey, theme }) => ({
    lineHeight: theme.spacing.xLarge,
    color: theme.colors[theme.colorMode][colorKey],
}));

export const SubscriptionMetaWrapper = styled.div({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
});
